module.exports = __webpack_public_path__ + "img/1557614080390406146.babee2bb.png";